// extracted by mini-css-extract-plugin
export default {"content":"NewModel_content__kwmuE"};